export const magdalenaDabrowska = {
    'mydrId': 'magdalenadąbrowska',
    'firstName': 'Magdalena',
    'lastName': 'Dąbrowska',
    'profession': 'Psycholog, Psychoterapeuta',
    'avatar': 'magdalena-dabrowska.webp',
    'slug': 'psycholog-psychoterapeuta-magdalena-dabrowska',
    'locations': ['torun'],
    'services': [
        ['psychoterapy', 'adult'],
        ['psychoterapy', 'children'],
        ['psychology', 'consultation'],
        ['diagnosis', 'autism'],
    ]
}